var _defs, _path, _path2, _path3, _rect, _path4, _rect2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPfsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 84.241,
    viewBox: "0 0 100 84.241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#205d66;}.b{fill:#7fa8ae;}.c{fill:#f77619;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-319.074,244.038c.625,0,.916-.3.916-.94,0-.713-.286-.979-1.037-.979h-1.144v1.919h1.265m-2.612-3h2.811a1.868,1.868,0,0,1,2.079,2.03,2.049,2.049,0,0,1-.533,1.527,2.627,2.627,0,0,1-1.725.528h-1.284v2.128h-1.347Z",
    transform: "translate(321.686 -203.066)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-310.609,244.789l-.746-2.147h-.015l-.746,2.147h1.507m-1.754-3.087c.179-.494.363-.664.746-.664h.445a.715.715,0,0,1,.582.218,1.069,1.069,0,0,1,.233.466l1.968,5.529h-1.381l-.49-1.391-2.161.005-.513,1.386h-1.405Z",
    transform: "translate(318.994 -203.066)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-301.287,247.251a3.387,3.387,0,0,1-2.156-.586,2.716,2.716,0,0,1-.921-2.408,3.365,3.365,0,0,1,.756-2.5,2.618,2.618,0,0,1,2.05-.717h1.836v1.08h-1.609c-1.206,0-1.658.563-1.658,2.065a2.359,2.359,0,0,0,.34,1.517,1.311,1.311,0,0,0,1.192.465h1.749v1.08Z",
    transform: "translate(315.339 -203.066)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.347,
    height: 6.213,
    transform: "translate(16.709 37.973)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-291.652,242.357c0-.853.509-1.318,1.449-1.318h3.024l-.015,1.08h-2.631c-.383,0-.48.087-.48.431v1.071h3.111l-.024,1.081H-290.3v2.544h-1.347Z",
    transform: "translate(310.681 -203.066)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 1.347,
    height: 6.213,
    transform: "translate(24.452 37.973)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-276.744,247.251a3.387,3.387,0,0,1-2.156-.586,2.716,2.716,0,0,1-.921-2.408,3.365,3.365,0,0,1,.756-2.5,2.618,2.618,0,0,1,2.05-.717h1.836v1.08h-1.609c-1.206,0-1.662.563-1.662,2.065a2.392,2.392,0,0,0,.339,1.517,1.312,1.312,0,0,0,1.192.465h1.749v1.08Z",
    transform: "translate(306.347 -203.066)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-268.157,242.357c0-.853.509-1.318,1.449-1.318h3.024l-.015,1.08h-2.631c-.383,0-.48.087-.48.431v1.071h3.116l-.024,1.081H-266.8v2.544h-1.347Z",
    transform: "translate(302.074 -203.066)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-258.442,241.038v4.022c0,.853.383,1.26,1.173,1.26a1.268,1.268,0,0,0,.911-.3,1.235,1.235,0,0,0,.363-1v-3.984h1.357v3.93a2.179,2.179,0,0,1-.664,1.778,2.784,2.784,0,0,1-1.987.65,2.489,2.489,0,0,1-1.9-.645,2.25,2.25,0,0,1-.572-1.347c-.02-.208-.024-.46-.024-.737v-3.629Z",
    transform: "translate(299.008 -203.066)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-250.141,241.038h1.343l2.34,4.153h.01v-4.153h1.347v6.213h-.814c-.45,0-.577-.073-.819-.494l-2.055-3.625h-.015v4.119h-1.343Z",
    transform: "translate(295.475 -203.066)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-237.992,246.165a1.311,1.311,0,0,0,.911-.373,2.3,2.3,0,0,0,.523-1.72,2.17,2.17,0,0,0-.407-1.5,1.262,1.262,0,0,0-1.085-.455h-1.241v4.046h1.3m-2.65-5.127h2.462a3.4,3.4,0,0,1,1.221.141,2.412,2.412,0,0,1,1.628,1.7,4.46,4.46,0,0,1,.131,1.168,3.252,3.252,0,0,1-.862,2.559,3.217,3.217,0,0,1-2.089.644h-2.5v-6.207Z",
    transform: "translate(291.995 -203.066)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-227,246.174h2.69c.431,0,.649-.243.649-.741s-.223-.722-.669-.722h-.921a2.364,2.364,0,0,1-1.57-.441,1.813,1.813,0,0,1-.485-1.415c0-1.217.63-1.807,1.948-1.807h2.521l0,1.08h-2.394a.658.658,0,0,0-.547.165.783.783,0,0,0-.2.577.764.764,0,0,0,.208.586c.125.112.281.151.644.151h1a1.63,1.63,0,0,1,1.808,1.841,1.727,1.727,0,0,1-.514,1.386,1.745,1.745,0,0,1-1.3.422H-227Z",
    transform: "translate(287.105 -203.069)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-217.208,244.654l-2.069-3.615h1.483l1.255,2.146,1.289-2.146h1.507l-2.112,3.634v2.578h-1.352Z",
    transform: "translate(284.165 -203.066)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-209.711,246.174h2.69c.431,0,.649-.243.649-.741s-.223-.722-.669-.722h-.921a2.364,2.364,0,0,1-1.57-.441,1.813,1.813,0,0,1-.485-1.415c0-1.217.63-1.807,1.948-1.807h2.52l0,1.08h-2.394a.658.658,0,0,0-.547.165.783.783,0,0,0-.2.577.764.764,0,0,0,.208.586c.125.112.281.151.644.151h1a1.63,1.63,0,0,1,1.808,1.841,1.727,1.727,0,0,1-.514,1.386,1.751,1.751,0,0,1-1.3.422h-2.869Z",
    transform: "translate(280.772 -203.069)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-199.588,242.124H-201.2v-1.085h4.739v1.085h-1.609l-.015,5.127h-1.507Z",
    transform: "translate(277.54 -203.066)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-191.088,247.253a1.4,1.4,0,0,1-.591-.073,1.144,1.144,0,0,1-.708-1.217v-3.489a1.4,1.4,0,0,1,.3-1.042,1.239,1.239,0,0,1,1.022-.388h3.131v1.081h-2.631c-.393,0-.47.067-.47.431v1.081h3.1v1.08h-3.1V245.8c0,.286.106.364.48.364h2.631v1.08Z",
    transform: "translate(274.312 -203.068)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-183.648,241.038h1.642l1.648,4.492h.015l1.691-4.492h1.643v6.213h-1.352v-3.78h-.015l-1.279,3.392c-.117.31-.252.4-.664.4-.324,0-.4-.01-.509-.082a.507.507,0,0,1-.2-.271l-1.284-3.465h-.015v3.809h-1.323Z",
    transform: "translate(271.113 -203.066)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-171.44,246.174h2.69c.431,0,.649-.243.649-.741s-.223-.722-.669-.722h-.921a2.364,2.364,0,0,1-1.57-.441,1.813,1.813,0,0,1-.485-1.415c0-1.217.63-1.807,1.948-1.807h2.521l0,1.08h-2.394a.658.658,0,0,0-.547.165.783.783,0,0,0-.2.577.766.766,0,0,0,.208.586c.126.112.281.151.645.151h1.008a1.63,1.63,0,0,1,1.807,1.841,1.729,1.729,0,0,1-.513,1.386,1.746,1.746,0,0,1-1.3.422h-2.869Z",
    transform: "translate(266.749 -203.069)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-282.162,275.576a34.634,34.634,0,0,1-5.68-19.057c0-.341.006-.681.016-1.019h-8.92a36.882,36.882,0,0,0,14.584,20.077",
    transform: "translate(312.549 -208.364)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-253.861,194.461a34.733,34.733,0,0,1,26.827,12.632,36.826,36.826,0,0,0-35.192-25.986,36.812,36.812,0,0,0-36.763,34.92h12.934a34.81,34.81,0,0,1,32.194-21.566",
    transform: "translate(313.37 -181.107)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-285.926,279.25a34.731,34.731,0,0,1-26.827-12.632A36.827,36.827,0,0,0-277.561,292.6a36.812,36.812,0,0,0,36.811-36.812c0-.1,0-.2-.005-.294h-12.162a34.815,34.815,0,0,1-33.009,23.751",
    transform: "translate(318.413 -208.364)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-224.45,207.982a34.615,34.615,0,0,1,5.658,17.892h8.212a36.92,36.92,0,0,0-13.87-17.892",
    transform: "translate(286.059 -190.953)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfsLogo);
export default __webpack_public_path__ + "static/media/pfs-logo.e944d527105550490eaacceff9a71aa1.svg";
export { ForwardRef as ReactComponent };